// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* start - для OrdersForm.js */
.orders-modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1600px;
    /* max-width: 1500; */
    /* background-color: background.paper; */
    background-color: #fff;
    border: 2px solid #000;
    box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12);
    padding: 15px;
}

.orders-modal__header {
    display: flex;
}

.orders-modal__header2 {
    display: flex;
}

.orders-modal__title2 {
    font-size: 1.25rem;
}
  
@media (max-width: 1600px) {
    .orders-modal {
        width: 95vw;
    }
}

@media (max-width: 1200px) {
    .orders-modal__header {
        display: block;
    }
}

@media (max-width: 992px) {
    .orders-modal {
        height: 98vh;
        overflow-x: auto;
    }
}

@media (max-width: 768px) {
    .orders-modal__header2 {
        display: block;
    }   
    .orders-modal__title2 {
        font-size: 1rem;
        margin-left: 0px !important;
    }
}

/* @media (max-width: 576px) { */
@media (max-width: 480px) {
    .orders-modal {
        padding-top: 50px;
    }
}
   
/* @media (max-width: 1200px) {
    .orders-modal {
        width: 970px
        width: 95vw;
        padding: calc(20px + (50 - 20) * ((100vw - 320px) / (1200 - 320)));
    }
} */

.orders__linkToOrderProduct {
    text-decoration: underline;
    color: rgb(3, 152, 158);
    cursor: pointer;
}

.orders__linkToOrderProductIcon {
    color: rgb(3, 152, 158);
    cursor: pointer;
}
  
.orders-choose__table {
    width: 100%;
}

.orders-choose__th {
    font-size: 14px;
}

.orders-choose__th-img {
    width: 50px;
}

.orders-choose__th-price {
    width: 50px;
}

.orders-choose__th-count {
    width: 90px;
}
.orders-choose__TC {
    display: flex;
    flex-direction: column;
}

.orders-choose__th-action {
    display: block;
    width: 35px;
}

.orders-choose__mobile, .orders-choose__short-mobile {
    display: none;
}
/* .orders-choose__PC, .orders-choose__short-PC {
    display: block;
} */

@media (max-width: 1400px) {
    .orders-choose__th-img {
        width: 40px;
    }
}

@media (max-width: 1200px) {
    .orders-choose__mobile{
        display: block;
    }
    .orders-choose__PC
    /* , .orders-choose__short-PC  */
    {
        display: none;
    }
    .orders-choose__th-img {
        width: 30px;
    }
    .orders-choose__th-action {
        display: none;
    }
}

@media (max-width: 991px) {
    .orders-choose__th-action {
        display: block;
        width: 35px;
    }
}

@media (max-width: 576px) {
    .orders-choose__short-PC {
        display: none;
    }
    .orders-choose__short-mobile {
        display: block;
    }
    .orders-choose__th-img {
        display: none;
    }
    .orders-choose__th-action {
        display: none;
    }
    .orders-choose__cart {
        display: none;
        width: 35px !important;
    }
}

.orders-choose__img {
    width: 50px;
}

.orders-choose__td-name {
    max-width: 150px;
    overflow: hidden;
    font-size: 14px;
}

.orders-choose__name {
    cursor: pointer;
    text-decoration: underLine;
    color: rgb(3, 152, 158);
}
  
.orders-choose__text {
    font-size: 14px;
    min-width: 100px;
}

.orders-choose__count {
    padding-left: 5px !important;
    padding-right: 5px !important;
    /* width: 90px; */
    width: 120px;
    line-height: 17px; 
}

.orders-choose__count-balance_container {
    border: 1px solid #ccc;
    background: #f1eeee;
    padding-bottom: 10px;
    border-radius: 10px;
    position: absolute;
    /* top: 10px; */
    top: 45px;
    right: 5px;
}

.orders-choose__count-balance_title-container {
    border-bottom: 1px solid #ccc;
    position: relative;
    min-height: 40px;
    max-height: 65px;
    background-color: #d6d7d8f2;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    align-items: center;
    padding: 10px;
}


.orders-choose__count-balance_title {
    font-weight: 600;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.orders-choose__count-balance_title-productName {
    max-width: 90%;
    font-size: 12px;
    margin-top: 5px;
    font-weight: 400;
}

.orders-choose__count-balance_storages {
    position: relative;
    padding: 10px;
    /* margin-bottom: 5px; */
    min-height: 100px;
    max-height: 222px;
    overflow: auto;
}

.orders-choose__count-balance_storages ul {
    list-style: none;
    padding-left: 10px;
}

.orders-choose__count-balance_storages ul li {
    font-size: 12px;
    margin-bottom: 4px;
}

.orders-choose__count-balance__btn-show {
    color: rgb(3, 152, 158) !important;
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer; 
}

.orders-choose__count-balance__btn-close {
    width: 25px;
    height: 25px;
    background-color: #6c757d;
    color: #fff;
    border: 1px solid transparent;
    border-radius: 5px;
    font-weight: 500;
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.orders-choose__count-balance__btn-close:hover {
    background-color: red;
    color: #000;
    border-color: #000;
}
.orders-choose__count-balance__btn-close:active {
    transform: scale(0.9);
}

.orders-choose__count-balance__btn-show:hover {
    cursor: pointer;
}

.orders-choose__count-1r {
    /* width: 90px; */
    width: 120px;
    margin-bottom: 5px;
}
.orders-choose__count-2r {
    /* width: 90px; */
    width: 120px;
    display: flex;
    justify-content: space-between;
}

.orders-choose__count-input {
    /* width: 90px; */
    width: 120px;
    font-size: 14px;
}

.orders-choose__count-button {
    /* width: 40px; */
    width: 50px;
    font-size: 14px;
}

.orders-choose__cart-mobile {
    display: none;
}

@media (max-width: 1400px) {
    .orders-choose__img {
        width: 40px;
    }
}

@media (max-width: 1200px) {
    .orders-choose__count-1r {
        width: 90px;
    }
    .orders-choose__count-2r {
        width: 90px;
    }
    .orders-choose__count-input {
        width: 90px;
    }
    .orders-choose__count-button {
        width: 40px;
    }
    
    /* .orders-choose__cart {
        display: none;
    } */
    .orders-choose__img {
        width: 30px;
    }
    .orders-choose__text {
        min-width: 80px;
    }
}

@media screen and (max-width: 991px) {
    .orders-choose__td-name {
        font-size: 16px;
    }
    .orders-choose__text {
        min-width: 115px;
        font-size: 16px;
    }

    .orders-choose__count-1r {
        width: 120px;
    }
    .orders-choose__count-2r {
        width: 120px;
    }
    .orders-choose__count-input {
        width: 120px;
    }
    .orders-choose__count-button {
        width: 50px;
    }

    .orders-choose__th-action {
        display: block;
    }
    .orders-choose__cart {
        display: block;
    }
}

@media (max-width: 576px) {
    .orders-choose__cart {
        display: none;
    }
    .orders-choose__td-img {
        display: none;
    }
    .orders-choose__th-action, .orders-choose__cart {
        display: none;
        padding: 3px !important;
    }
    .orders-choose__td-name, .orders-choose__text {
        font-size: 14px;
        min-width: 60px;
    }

    .orders-choose__count-1r {
        width: 90px;
    }
    .orders-choose__count-2r {
        width: 90px;
    }
    .orders-choose__count-input {
        width: 90px;
    }
    .orders-choose__count-button {
        width: 40px;
    }

    .orders-choose__cart-mobile {
        display: block;
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 90px;
        /* width: 120px; */
    }
}

@media screen and (max-width: 448px) {  
    .orders-choose__td-name, .orders-choose__text {
        font-size: 13px;
    }

    .orders-choose__count-1r, .orders-choose__count-2r {
        width: 100%;
    }

    .orders-choose__count-input {
        width: 100%;
    }
    
    .orders-choose__count-button {
        width: 100%;
    }
  }


/* Start - для ViewOrdersMain.js */
.orders-ViewMain__TC {
    display: flex;
    flex-direction: column;
}
/* End - для ViewOrdersMoin.js */


/* Start - для ViewOrdersModal.js */
.orders-ViewModal__mobile {
    display: none;
}
.orders-ViewModal__PC {
    display: block;
}
.orders-ViewModal__TC {
    display: flex;
    flex-direction: column;
}

/* .orders-ViewModal__container-PC */
.orders-ViewModal__container-mobile {
    /* display: block; */
    display: none;
}

@media (max-width: 1200px) {
    .orders-ViewModal__mobile {
        display: block;
    }
    .orders-ViewModal__PC {
        display: none !important;
    }
}

/* End - для ViewOrdersModal.js */


/* Start - для ProductInfo.js */
.orders-productInfo__text {
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 5px;
}

.orders-productInfo__count {
    width: 100%;
    display: flex;
}

.orders-productInfo__count-btn {
    width: 45px;
}

.orders-productInfo__count-input {
    width: 100%;
}

.orders-productInfo__btn-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

@media (max-width: 1200px) {
    .orders-productInfo__count, .orders-productInfo__btn-container {
        width: 217px;
    }
}

/* End - для ProductInfo.js */

.orders-update_modal-updateProductItem {
    width: 900px;
}

@media (max-width: 991px) {
    .orders-update_modal-updateProductItem {
        max-width: 500px;
    }
} 
@media (max-width: 576px) {
    .orders-update_modal-updateProductItem {
        width: 90%;
    }
} 


/* Start - для UpdateProductItem.js */
.orders-update__text {
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 5px;
}
.orders-update__input-price {
    width: 100%;
    font-size: 17px;
    text-align: center;
}

.orders-update__btn-counter {
    height: 28px;
    width: 28px;
    font-size: 17px;
}

.orders-update__input-counter {
    width: calc(100% - 30px);
    font-size: 17px;
}

/* End - для UpdateProductItem.js */


.orders-tableHeader {
    padding-left: 12px;
    font-size: 20px;
    color: rgb(33, 37, 41);
    font-weight: 500;
    letter-spacing: 0.15px;
    line-height: 32px;
}

.orders-CAccordion {
    font-size: 14px;
}

.orders-filterSize {
    font-size: 13px !important;
}

@media (max-width: 991px) {
    .orders-tableHeader {
        line-height: 25px;
    }
}

@media (max-width: 576px) {
    .orders-tableHeader {
        padding-left: 0px;
    }

    .orders-ViewModal__container-PC {
        /* display: block; */
        display: none;
    }
    .orders-ViewModal__container-mobile {
        display: block;
        /* display: none; */
    }
}
  
/* start orders page QuickProductAddition */
.orders-btn__close {
    width: 106px;
    line-height: 17px !important;
    padding: 0px 2px 5px 2px !important;
    cursor: pointer !important;
    position: absolute;
    /* top: -40px; */
    top: -5px;
    right: -10px;
    border: 1px solid #000;
    text-align: center;
}
.orders-btn__close:hover {
    background-color: red !important;
    color: #000 !important;
}
.orders-btn__close:active {
    transform: scale(0.9);
}

.orders-quickProductAddition__btn-close {
    width: 25px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
    background-color: #6c757d;
    color: #fff;
    border-radius: 5px;
    font-weight: 500;
    position: absolute;
    top: -65px;
    right: -25px;
    cursor: pointer;
}
.orders-quickProductAddition__btn-close:hover {
    background-color: red;
    color: #000;
    border: 1px solid #000;
}
.orders-quickProductAddition__btn-close:active {
    transform: scale(0.9);
}

@media (max-width: 1200px) {
    .orders-btn__close {
        /* top: -70px; */
        top: -5px;
    }
}

@media (max-width: 768px) {
    .orders-btn__close {
        /* top: -90px; */
        top: -5px;
    }
}

/* @media (max-width: 576px) { */
@media (max-width: 480px) {
    .orders-btn__close {
        /* top: -75px; */
        /* top: -130px; */
        top: -40px;
    }
}

@media (max-width: 403px) {
    .orders-quickProductAddition__btn-close {
        top: -95px;
        right: -25px;
    }
}

@media (max-width: 350px) {
    .orders-btn__close {
        top: -140px;
    }
}
  
/* end orders page QuickProductAddition */
  
/* start orders page AddProductToOrder */
.orders-chooseProduct__container {
    margin-top: 5px;
    padding: 0px 5px 5px;
    border: 5px solid grey;
}
  
@media (max-width: 991px) {
    .orders-chooseProduct__container {
        border: none;
        border-top: 7px solid grey;
        margin-top: 30px;
    }
}
  
.orders-viewProductOrders__container {
    margin-top: 5px;
    padding: 0px 5px 5px;
    border: 5px solid grey;
}
  
@media (max-width: 991px) {
    .orders-viewProductOrders__container {
        border: none;
        border-top: 7px solid grey;
        margin-top: 15px;
    }
}
@media (max-width: 850px) {
    .order-updateProductItem {
        width: 90%;
    }
}
  
.orders-productInfo__container, .orders-updateProductItem__container {
    margin-top: 5px;
    border: 5px solid grey;
}
  
.orders-productInfo__btn-close, .orders-updateProductItems__btn-close {
    width: 25px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
    background-color: #6c757d;
    color: #fff;
    border-radius: 5px;
    font-weight: 500;
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
}
.orders-productInfo__btn-close:hover, .orders-updateProductItems__btn-close:hover {
    background-color: red;
    color: #000;
    border: 1px solid #000;
}
.orders-productInfo__btn-close:active, .orders-updateProductItems__btn-close:active {
    transform: scale(0.9);
}

.orders-updateProductItems__photo {
    position: relative;
    height: 200px;
    width: 200px;
}

.orders-updateProductItems__photo img {
    width: 100%;
}
  
.orders-updateProductItems__photo:after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0; left: 0;
    background-color: rgba(0,0,0,0.5);
}

@media (max-width: 991px) {
    .orders-productInfo__container, .orders-updateProductItem__container {
        border: none;
        border-top: 7px solid grey;
        margin-top: 15px;
    }
}

/* end orders page AddProductToOrder */`, "",{"version":3,"sources":["webpack://./src/styles/orders.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,qBAAqB;IACrB,wCAAwC;IACxC,sBAAsB;IACtB,sBAAsB;IACtB,qHAAqH;IACrH,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,eAAe;QACf,2BAA2B;IAC/B;AACJ;;AAEA,gCAAgC;AAChC;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;;;;;;GAMG;;AAEH;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;AACA;;GAEG;;AAEH;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;IACA;;;QAGI,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;;IAEA;;OAEG;IACH;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;EACF;;;AAGF,kCAAkC;AAClC;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA,gCAAgC;;;AAGhC,mCAAmC;AACnC;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA,oCAAoC;AACpC;IACI,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA,iCAAiC;;;AAGjC,+BAA+B;AAC/B;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA,6BAA6B;;AAE7B;IACI,YAAY;AAChB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,UAAU;IACd;AACJ;;;AAGA,qCAAqC;AACrC;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA,mCAAmC;;;AAGnC;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;QACpB,aAAa;IACjB;IACA;QACI,cAAc;QACd,mBAAmB;IACvB;AACJ;;AAEA,2CAA2C;AAC3C;IACI,YAAY;IACZ,4BAA4B;IAC5B,mCAAmC;IACnC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,gCAAgC;IAChC,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,SAAS;IACb;AACJ;;AAEA,gCAAgC;AAChC;IACI;QACI,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA,yCAAyC;;AAEzC,wCAAwC;AACxC;IACI,eAAe;IACf,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI;QACI,YAAY;QACZ,0BAA0B;QAC1B,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI;QACI,YAAY;QACZ,0BAA0B;QAC1B,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM,EAAE,OAAO;IACf,iCAAiC;AACrC;;AAEA;IACI;QACI,YAAY;QACZ,0BAA0B;QAC1B,gBAAgB;IACpB;AACJ;;AAEA,sCAAsC","sourcesContent":["/* start - для OrdersForm.js */\n.orders-modal {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 1600px;\n    /* max-width: 1500; */\n    /* background-color: background.paper; */\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12);\n    padding: 15px;\n}\n\n.orders-modal__header {\n    display: flex;\n}\n\n.orders-modal__header2 {\n    display: flex;\n}\n\n.orders-modal__title2 {\n    font-size: 1.25rem;\n}\n  \n@media (max-width: 1600px) {\n    .orders-modal {\n        width: 95vw;\n    }\n}\n\n@media (max-width: 1200px) {\n    .orders-modal__header {\n        display: block;\n    }\n}\n\n@media (max-width: 992px) {\n    .orders-modal {\n        height: 98vh;\n        overflow-x: auto;\n    }\n}\n\n@media (max-width: 768px) {\n    .orders-modal__header2 {\n        display: block;\n    }   \n    .orders-modal__title2 {\n        font-size: 1rem;\n        margin-left: 0px !important;\n    }\n}\n\n/* @media (max-width: 576px) { */\n@media (max-width: 480px) {\n    .orders-modal {\n        padding-top: 50px;\n    }\n}\n   \n/* @media (max-width: 1200px) {\n    .orders-modal {\n        width: 970px\n        width: 95vw;\n        padding: calc(20px + (50 - 20) * ((100vw - 320px) / (1200 - 320)));\n    }\n} */\n\n.orders__linkToOrderProduct {\n    text-decoration: underline;\n    color: rgb(3, 152, 158);\n    cursor: pointer;\n}\n\n.orders__linkToOrderProductIcon {\n    color: rgb(3, 152, 158);\n    cursor: pointer;\n}\n  \n.orders-choose__table {\n    width: 100%;\n}\n\n.orders-choose__th {\n    font-size: 14px;\n}\n\n.orders-choose__th-img {\n    width: 50px;\n}\n\n.orders-choose__th-price {\n    width: 50px;\n}\n\n.orders-choose__th-count {\n    width: 90px;\n}\n.orders-choose__TC {\n    display: flex;\n    flex-direction: column;\n}\n\n.orders-choose__th-action {\n    display: block;\n    width: 35px;\n}\n\n.orders-choose__mobile, .orders-choose__short-mobile {\n    display: none;\n}\n/* .orders-choose__PC, .orders-choose__short-PC {\n    display: block;\n} */\n\n@media (max-width: 1400px) {\n    .orders-choose__th-img {\n        width: 40px;\n    }\n}\n\n@media (max-width: 1200px) {\n    .orders-choose__mobile{\n        display: block;\n    }\n    .orders-choose__PC\n    /* , .orders-choose__short-PC  */\n    {\n        display: none;\n    }\n    .orders-choose__th-img {\n        width: 30px;\n    }\n    .orders-choose__th-action {\n        display: none;\n    }\n}\n\n@media (max-width: 991px) {\n    .orders-choose__th-action {\n        display: block;\n        width: 35px;\n    }\n}\n\n@media (max-width: 576px) {\n    .orders-choose__short-PC {\n        display: none;\n    }\n    .orders-choose__short-mobile {\n        display: block;\n    }\n    .orders-choose__th-img {\n        display: none;\n    }\n    .orders-choose__th-action {\n        display: none;\n    }\n    .orders-choose__cart {\n        display: none;\n        width: 35px !important;\n    }\n}\n\n.orders-choose__img {\n    width: 50px;\n}\n\n.orders-choose__td-name {\n    max-width: 150px;\n    overflow: hidden;\n    font-size: 14px;\n}\n\n.orders-choose__name {\n    cursor: pointer;\n    text-decoration: underLine;\n    color: rgb(3, 152, 158);\n}\n  \n.orders-choose__text {\n    font-size: 14px;\n    min-width: 100px;\n}\n\n.orders-choose__count {\n    padding-left: 5px !important;\n    padding-right: 5px !important;\n    /* width: 90px; */\n    width: 120px;\n    line-height: 17px; \n}\n\n.orders-choose__count-balance_container {\n    border: 1px solid #ccc;\n    background: #f1eeee;\n    padding-bottom: 10px;\n    border-radius: 10px;\n    position: absolute;\n    /* top: 10px; */\n    top: 45px;\n    right: 5px;\n}\n\n.orders-choose__count-balance_title-container {\n    border-bottom: 1px solid #ccc;\n    position: relative;\n    min-height: 40px;\n    max-height: 65px;\n    background-color: #d6d7d8f2;\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n    align-items: center;\n    padding: 10px;\n}\n\n\n.orders-choose__count-balance_title {\n    font-weight: 600;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.orders-choose__count-balance_title-productName {\n    max-width: 90%;\n    font-size: 12px;\n    margin-top: 5px;\n    font-weight: 400;\n}\n\n.orders-choose__count-balance_storages {\n    position: relative;\n    padding: 10px;\n    /* margin-bottom: 5px; */\n    min-height: 100px;\n    max-height: 222px;\n    overflow: auto;\n}\n\n.orders-choose__count-balance_storages ul {\n    list-style: none;\n    padding-left: 10px;\n}\n\n.orders-choose__count-balance_storages ul li {\n    font-size: 12px;\n    margin-bottom: 4px;\n}\n\n.orders-choose__count-balance__btn-show {\n    color: rgb(3, 152, 158) !important;\n    font-size: 14px;\n    text-decoration: underline;\n    cursor: pointer; \n}\n\n.orders-choose__count-balance__btn-close {\n    width: 25px;\n    height: 25px;\n    background-color: #6c757d;\n    color: #fff;\n    border: 1px solid transparent;\n    border-radius: 5px;\n    font-weight: 500;\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.orders-choose__count-balance__btn-close:hover {\n    background-color: red;\n    color: #000;\n    border-color: #000;\n}\n.orders-choose__count-balance__btn-close:active {\n    transform: scale(0.9);\n}\n\n.orders-choose__count-balance__btn-show:hover {\n    cursor: pointer;\n}\n\n.orders-choose__count-1r {\n    /* width: 90px; */\n    width: 120px;\n    margin-bottom: 5px;\n}\n.orders-choose__count-2r {\n    /* width: 90px; */\n    width: 120px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.orders-choose__count-input {\n    /* width: 90px; */\n    width: 120px;\n    font-size: 14px;\n}\n\n.orders-choose__count-button {\n    /* width: 40px; */\n    width: 50px;\n    font-size: 14px;\n}\n\n.orders-choose__cart-mobile {\n    display: none;\n}\n\n@media (max-width: 1400px) {\n    .orders-choose__img {\n        width: 40px;\n    }\n}\n\n@media (max-width: 1200px) {\n    .orders-choose__count-1r {\n        width: 90px;\n    }\n    .orders-choose__count-2r {\n        width: 90px;\n    }\n    .orders-choose__count-input {\n        width: 90px;\n    }\n    .orders-choose__count-button {\n        width: 40px;\n    }\n    \n    /* .orders-choose__cart {\n        display: none;\n    } */\n    .orders-choose__img {\n        width: 30px;\n    }\n    .orders-choose__text {\n        min-width: 80px;\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .orders-choose__td-name {\n        font-size: 16px;\n    }\n    .orders-choose__text {\n        min-width: 115px;\n        font-size: 16px;\n    }\n\n    .orders-choose__count-1r {\n        width: 120px;\n    }\n    .orders-choose__count-2r {\n        width: 120px;\n    }\n    .orders-choose__count-input {\n        width: 120px;\n    }\n    .orders-choose__count-button {\n        width: 50px;\n    }\n\n    .orders-choose__th-action {\n        display: block;\n    }\n    .orders-choose__cart {\n        display: block;\n    }\n}\n\n@media (max-width: 576px) {\n    .orders-choose__cart {\n        display: none;\n    }\n    .orders-choose__td-img {\n        display: none;\n    }\n    .orders-choose__th-action, .orders-choose__cart {\n        display: none;\n        padding: 3px !important;\n    }\n    .orders-choose__td-name, .orders-choose__text {\n        font-size: 14px;\n        min-width: 60px;\n    }\n\n    .orders-choose__count-1r {\n        width: 90px;\n    }\n    .orders-choose__count-2r {\n        width: 90px;\n    }\n    .orders-choose__count-input {\n        width: 90px;\n    }\n    .orders-choose__count-button {\n        width: 40px;\n    }\n\n    .orders-choose__cart-mobile {\n        display: block;\n        margin-top: 10px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 90px;\n        /* width: 120px; */\n    }\n}\n\n@media screen and (max-width: 448px) {  \n    .orders-choose__td-name, .orders-choose__text {\n        font-size: 13px;\n    }\n\n    .orders-choose__count-1r, .orders-choose__count-2r {\n        width: 100%;\n    }\n\n    .orders-choose__count-input {\n        width: 100%;\n    }\n    \n    .orders-choose__count-button {\n        width: 100%;\n    }\n  }\n\n\n/* Start - для ViewOrdersMain.js */\n.orders-ViewMain__TC {\n    display: flex;\n    flex-direction: column;\n}\n/* End - для ViewOrdersMoin.js */\n\n\n/* Start - для ViewOrdersModal.js */\n.orders-ViewModal__mobile {\n    display: none;\n}\n.orders-ViewModal__PC {\n    display: block;\n}\n.orders-ViewModal__TC {\n    display: flex;\n    flex-direction: column;\n}\n\n/* .orders-ViewModal__container-PC */\n.orders-ViewModal__container-mobile {\n    /* display: block; */\n    display: none;\n}\n\n@media (max-width: 1200px) {\n    .orders-ViewModal__mobile {\n        display: block;\n    }\n    .orders-ViewModal__PC {\n        display: none !important;\n    }\n}\n\n/* End - для ViewOrdersModal.js */\n\n\n/* Start - для ProductInfo.js */\n.orders-productInfo__text {\n    font-size: 14px;\n    line-height: 17px;\n    margin-bottom: 5px;\n}\n\n.orders-productInfo__count {\n    width: 100%;\n    display: flex;\n}\n\n.orders-productInfo__count-btn {\n    width: 45px;\n}\n\n.orders-productInfo__count-input {\n    width: 100%;\n}\n\n.orders-productInfo__btn-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@media (max-width: 1200px) {\n    .orders-productInfo__count, .orders-productInfo__btn-container {\n        width: 217px;\n    }\n}\n\n/* End - для ProductInfo.js */\n\n.orders-update_modal-updateProductItem {\n    width: 900px;\n}\n\n@media (max-width: 991px) {\n    .orders-update_modal-updateProductItem {\n        max-width: 500px;\n    }\n} \n@media (max-width: 576px) {\n    .orders-update_modal-updateProductItem {\n        width: 90%;\n    }\n} \n\n\n/* Start - для UpdateProductItem.js */\n.orders-update__text {\n    font-size: 14px;\n    line-height: 17px;\n    margin-bottom: 5px;\n}\n.orders-update__input-price {\n    width: 100%;\n    font-size: 17px;\n    text-align: center;\n}\n\n.orders-update__btn-counter {\n    height: 28px;\n    width: 28px;\n    font-size: 17px;\n}\n\n.orders-update__input-counter {\n    width: calc(100% - 30px);\n    font-size: 17px;\n}\n\n/* End - для UpdateProductItem.js */\n\n\n.orders-tableHeader {\n    padding-left: 12px;\n    font-size: 20px;\n    color: rgb(33, 37, 41);\n    font-weight: 500;\n    letter-spacing: 0.15px;\n    line-height: 32px;\n}\n\n.orders-CAccordion {\n    font-size: 14px;\n}\n\n.orders-filterSize {\n    font-size: 13px !important;\n}\n\n@media (max-width: 991px) {\n    .orders-tableHeader {\n        line-height: 25px;\n    }\n}\n\n@media (max-width: 576px) {\n    .orders-tableHeader {\n        padding-left: 0px;\n    }\n\n    .orders-ViewModal__container-PC {\n        /* display: block; */\n        display: none;\n    }\n    .orders-ViewModal__container-mobile {\n        display: block;\n        /* display: none; */\n    }\n}\n  \n/* start orders page QuickProductAddition */\n.orders-btn__close {\n    width: 106px;\n    line-height: 17px !important;\n    padding: 0px 2px 5px 2px !important;\n    cursor: pointer !important;\n    position: absolute;\n    /* top: -40px; */\n    top: -5px;\n    right: -10px;\n    border: 1px solid #000;\n    text-align: center;\n}\n.orders-btn__close:hover {\n    background-color: red !important;\n    color: #000 !important;\n}\n.orders-btn__close:active {\n    transform: scale(0.9);\n}\n\n.orders-quickProductAddition__btn-close {\n    width: 25px;\n    height: 25px;\n    text-align: center;\n    vertical-align: middle;\n    background-color: #6c757d;\n    color: #fff;\n    border-radius: 5px;\n    font-weight: 500;\n    position: absolute;\n    top: -65px;\n    right: -25px;\n    cursor: pointer;\n}\n.orders-quickProductAddition__btn-close:hover {\n    background-color: red;\n    color: #000;\n    border: 1px solid #000;\n}\n.orders-quickProductAddition__btn-close:active {\n    transform: scale(0.9);\n}\n\n@media (max-width: 1200px) {\n    .orders-btn__close {\n        /* top: -70px; */\n        top: -5px;\n    }\n}\n\n@media (max-width: 768px) {\n    .orders-btn__close {\n        /* top: -90px; */\n        top: -5px;\n    }\n}\n\n/* @media (max-width: 576px) { */\n@media (max-width: 480px) {\n    .orders-btn__close {\n        /* top: -75px; */\n        /* top: -130px; */\n        top: -40px;\n    }\n}\n\n@media (max-width: 403px) {\n    .orders-quickProductAddition__btn-close {\n        top: -95px;\n        right: -25px;\n    }\n}\n\n@media (max-width: 350px) {\n    .orders-btn__close {\n        top: -140px;\n    }\n}\n  \n/* end orders page QuickProductAddition */\n  \n/* start orders page AddProductToOrder */\n.orders-chooseProduct__container {\n    margin-top: 5px;\n    padding: 0px 5px 5px;\n    border: 5px solid grey;\n}\n  \n@media (max-width: 991px) {\n    .orders-chooseProduct__container {\n        border: none;\n        border-top: 7px solid grey;\n        margin-top: 30px;\n    }\n}\n  \n.orders-viewProductOrders__container {\n    margin-top: 5px;\n    padding: 0px 5px 5px;\n    border: 5px solid grey;\n}\n  \n@media (max-width: 991px) {\n    .orders-viewProductOrders__container {\n        border: none;\n        border-top: 7px solid grey;\n        margin-top: 15px;\n    }\n}\n@media (max-width: 850px) {\n    .order-updateProductItem {\n        width: 90%;\n    }\n}\n  \n.orders-productInfo__container, .orders-updateProductItem__container {\n    margin-top: 5px;\n    border: 5px solid grey;\n}\n  \n.orders-productInfo__btn-close, .orders-updateProductItems__btn-close {\n    width: 25px;\n    height: 25px;\n    text-align: center;\n    vertical-align: middle;\n    background-color: #6c757d;\n    color: #fff;\n    border-radius: 5px;\n    font-weight: 500;\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    cursor: pointer;\n}\n.orders-productInfo__btn-close:hover, .orders-updateProductItems__btn-close:hover {\n    background-color: red;\n    color: #000;\n    border: 1px solid #000;\n}\n.orders-productInfo__btn-close:active, .orders-updateProductItems__btn-close:active {\n    transform: scale(0.9);\n}\n\n.orders-updateProductItems__photo {\n    position: relative;\n    height: 200px;\n    width: 200px;\n}\n\n.orders-updateProductItems__photo img {\n    width: 100%;\n}\n  \n.orders-updateProductItems__photo:after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0; left: 0;\n    background-color: rgba(0,0,0,0.5);\n}\n\n@media (max-width: 991px) {\n    .orders-productInfo__container, .orders-updateProductItem__container {\n        border: none;\n        border-top: 7px solid grey;\n        margin-top: 15px;\n    }\n}\n\n/* end orders page AddProductToOrder */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
